import { DOMSerializer } from 'prosemirror-model'
import { downgradeCustomExtensionsForDocumentElement } from './downgradeCustomExtensionsForElement.mjs'

/**
 *
 * This is a custom fragment serializer for TipTap.  It's used to adjust the
 * clipboard html to be more plain html that can be pasted into other
 * contexts.
 *
 *
 * @param schema the prose mirror schema to use
 * @param fragment the fragment to serialize
 * @param options the options to use for serialization
 * @param target the target to serialize to
 * @param getResource a synchronous function that takes a resource type and id and returns the resource
 * @return {HTMLElement | DocumentFragment} the adjusted serialized fragment
 */
//

export function downgradeCustomExtensionsToPlainHtml(
  schema,
  fragment,
  options,
  target,
  getResource = (resourceType, resourceId) => null,
) {
  // Use the built-in serializer to get the default result
  const defaultResult = DOMSerializer.fromSchema(schema).serializeFragment(
    fragment,
    options,
    target,
  )

  let div = document.createElement('div')
  div.appendChild(defaultResult.cloneNode(true))
  downgradeCustomExtensionsForDocumentElement(defaultResult, getResource)

  // For debugging:
  // const document = createHTMLDocument()
  // let div = document.createElement('div')
  // div.appendChild(defaultResult.cloneNode(true))
  // console.log('downgraded html:', div.innerHTML)
  return defaultResult
}
